import * as React from 'react';

import EntityName, { EntityNameDefaultProps } from './EntityName';

import { getEntityFromCampaign } from 'utils/view';

import type { Campaign, CampaignAdminPreview } from 'types';
import type { EntityNameProps } from './EntityName';

type Props = EntityNameProps & {
  campaign: Campaign | CampaignAdminPreview,
  disabled?: boolean
};

/* $FlowIgnore - Cannot create an element because of spread issue */
function CampaignEntityName(
  {
    campaign,
    disabled,
    ...props
  }: Props
) {
  const entity = getEntityFromCampaign(campaign);

  return (
    <EntityName
      entity={entity}
      link={disabled ? '' : entity?.url}
      {...props}
    />
  );
}

CampaignEntityName.defaultProps = EntityNameDefaultProps;

export default CampaignEntityName;
